import React, { type FC } from 'react'

import { useIntl } from 'react-intl'

import {
  FormElement,
  SELECT_VARIANT_WITH_CHECKBOX,
  Select,
} from 'mailup-web-components'

import { useRecoilCallback, useRecoilValue } from 'recoil'

import { modalSubscribeChangeCallback } from 'Pages/RecipientsList/recoil/callbacks/modalSubscribe'
import { modalSubscribeState } from 'Pages/RecipientsList/recoil/state/modalSubscribe'

import { listsState } from 'Pages/RecipientsList/recoil/state/common'
import InputSelectAllLists from './InputSelectAllLists'

const InputLists: FC = () => {
  const intl = useIntl()

  const { lists, allLists, listsIsDirty } = useRecoilValue(modalSubscribeState)

  const { items } = useRecoilValue(listsState)

  const change = useRecoilCallback(modalSubscribeChangeCallback, [])

  const handleChangeLists = (v: number[]): void => {
    void change({
      lists: v,
      listsIsDirty: true,
    })
  }

  const notValid = listsIsDirty && lists.length === 0 && !allLists

  const feedback = notValid
    ? intl.formatMessage({
        id: 'Load.MailupCommon.Required',
      })
    : undefined

  const feedbackVariant = notValid ? 'error' : undefined

  return (
    <FormElement
      required
      label={intl.formatMessage({
        id: 'Load.RecipientsList.ModalSubscribeChooseLists',
      })}
      LabelRightComponent={InputSelectAllLists}
      feedback={feedback}
      feedbackVariant={feedbackVariant}
    >
      <Select
        multiple
        variant={SELECT_VARIANT_WITH_CHECKBOX}
        value={lists}
        options={items}
        onChange={handleChangeLists}
        data-mu-test="input-lists"
        disabled={allLists}
        placeholder={intl.formatMessage({
          id: 'Load.Common.PlaceHolderSelectMultipleList',
        })}
        error={notValid}
      />
    </FormElement>
  )
}

export default InputLists
